import React  from 'react';
import UsersComponentProto from './users-proto/users-proto';

export default function renderDateInView(id, props) {
    return <UsersComponentProto renderMode="view" id={id} {...props} />;
}